import { Component, Input } from '@angular/core';

export function getStringForActiveState(isActive: boolean): string {
    return isActive ? 'Active' : 'Inactive';
}

@Component({
    selector: 'cdp-active-status-display',
    templateUrl: './active-status-display.component.html',
    styleUrls: ['./active-status-display.component.scss'],
    standalone: false
})
export class ActiveStatusDisplayComponent {
    @Input() search = '';
    @Input() set isActive(_isActive: boolean) {
        this._isActive = _isActive;
        this._statusIco = _isActive ? 'icon-status-success' : 'icon-status-cancelled';
        this._statusStr = getStringForActiveState(_isActive);
    }
    public get isActive(): boolean {
        return this._isActive;
    }
    public get statusIco(): string {
        return this._statusIco;
    }
    private _statusIco = 'icon-status-success';

    public get statusStr(): string {
        return this._statusStr;
    }
    private _statusStr = 'Active';

    private _isActive = false;
}
